@if (isOpen) {
	<div class="backdrop fade">
		<div
			[attr.aria-label]="dialogAriaLabel()"class="dialog-container"
			(click)="close($event, true)"
			animate.enter="stages-dialog-fade-in"
			animate.leave="stages-dialog-fade-out"
			(animationend)="fadeInOutDone($event)"
		>
			<ng-content></ng-content>
		</div>
	</div>
}
